import {
  getModelId,
  IActionsMixin, IMetaMixin, IModelConstructor,
  Model, PureModel,
} from '@datx/core';
import { IJsonapiModel, jsonapiAngular } from '@datx/jsonapi-angular';
import { IRawModel } from '@datx/utils';
import { PureCollection } from '@datx/core/PureCollection';
import { IMetaPatchesModel } from '@datx/core/interfaces/IMetaPatchesModel';
import { isMongoId } from '../util';

// These types are needed, due to TypeScript's limitations in inferring types from mixin functions
type ModelBase = IMetaPatchesModel &
  IActionsMixin<IMetaMixin & PureModel> &
  IMetaMixin &
  PureModel;

type JsonApiModelConstructor = IModelConstructor<ModelBase & IJsonapiModel>;

/**
 * enableAutoId has no effect, @see: https://github.com/infinum/datx/issues/1214
 */
export class JsonApiModel extends (jsonapiAngular(Model) as JsonApiModelConstructor) {
  public static override enableAutoId = false;

  constructor(rawData?: IRawModel, collection?: PureCollection) {
    super(rawData, collection);
  }

  public hasId(): boolean {
    return isMongoId(getModelId(this));
  }
}
